import settings from '../setting';
import axios from 'axios';

const headers = {
    'X-Api-Key': settings.apiKey
  }


 function uploadImagesToTemporaryStore (formData: FormData, tempUniqueSessionId: string){    
    const url = `${settings.baseDamCardamageUrl}/${settings.baseDamCardamageUploadFolder}/${tempUniqueSessionId}/`;    

    return axios({
        url,
        method: 'post',
        headers,
        data: formData
    });             
}

function setImagesToStore  (tempUniqueSessionId: string = '', partnerId: string = 'eda123abc', regNr: string = '12ABC123A') {
    const url = `${settings.baseDamCardamageUrl}/${settings.baseDamCardamageMoveImagesUrlPart}/?sessionId=${tempUniqueSessionId}&partnerId=${partnerId}&regNr=${regNr}`;    

    return  axios({
        url,
        method: 'post',
        headers
    });        
}

function deleteImagesFromTemporaryStore  (tempUniqueSessionId: string = '', fileName: string) {
    const url = `${settings.baseDamCardamageUrl}/${settings.baseDamCardamageUploadFolder}/${tempUniqueSessionId}/${fileName}`; 

    return  axios({
        url,
        method: 'delete',
        headers
    });        
}

export {uploadImagesToTemporaryStore, setImagesToStore , deleteImagesFromTemporaryStore};